export default __webpack_public_path__ + "static/bg-experience-02b1b1037d97d688f0f5383342ec3322.png";